export default function validateToken(token) {
  if (!token) return false;

  const proxy = String(token);

  if (proxy.length < 64) return false;

  try {
    const decoded = JSON.parse(proxy);

    return !decoded;
  } catch (err) {
    return true;
  }
}
